import axios from "axios";

const { REACT_APP_BASE_URL } = process.env;

export const getPreInventory = async (token, results = 20, page = 1) => {
  let url = `${REACT_APP_BASE_URL}/properties?results=${results}&page=${page}&status=Inventario&preInventory=true`;

  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    const err = error?.response?.data?.error ?? {};
    const response =
      err?.type === "VALIDATION_ERROR"
        ? err.errors[0]?.msg
        : err?.message ?? "Error en la petición";

    return Promise.reject(response);
  }
};
